import React from 'react';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useInView } from 'react-intersection-observer';

const Timeline: React.FC = () => {
  const { t } = useTranslation('about');
  const [ref, inView] = useInView({
    triggerOnce: true,
    threshold: 0.1,
  });

  const timeline = t('timeline', { returnObjects: true }) as Array<{
    year: string;
    title: string;
    description: string;
  }>;

  return (
    <section className="py-20 section-dark" ref={ref}>
      <div className="container-custom">
        <motion.div
          className="text-center mb-16"
          initial={{ opacity: 0, y: 30 }}
          animate={inView ? { opacity: 1, y: 0 } : {}}
          transition={{ duration: 0.6 }}
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4 gradient-text">
            {t('timelineSection.title')}
          </h2>
          <p className="text-xl text-secondary max-w-2xl mx-auto">
            {t('timelineSection.subtitle')}
          </p>
        </motion.div>

        <div className="max-w-3xl mx-auto">
          {timeline.map((item, index) => (
            <motion.div
              key={index}
              className="relative pl-8 pb-12 last:pb-0"
              initial={{ opacity: 0, x: -30 }}
              animate={inView ? { opacity: 1, x: 0 } : {}}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <div className="absolute left-0 top-0 w-4 h-4 bg-primary-500 rounded-full" />
              {index < timeline.length - 1 && (
                <div className="absolute left-[7px] top-4 bottom-0 w-0.5 bg-gray-300 dark:bg-dark-border" />
              )}
              <div className="card p-6 ml-4">
                <div className="text-primary-500 font-bold text-lg mb-2">
                  {item.year}
                </div>
                <h3 className="text-xl font-bold mb-2">{item.title}</h3>
                <p className="text-secondary">{item.description}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Timeline;
